import axios from "axios";
import authentication from "@/authentication";

export default {
  baseUrl: process.env.VUE_APP_API_TIME_TRACKING_BASE,
  async loadGroups() {
    await authentication.isAuthenticated();
    return axios
      .get(this.baseUrl + "/GetGroups", {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async loadHours() {
    await authentication.isAuthenticated();
    return axios
      .get(this.baseUrl + "/GetHours", {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async save(settings) {
    await authentication.isAuthenticated();
    return axios
      .post(this.baseUrl + "/SaveHours", settings, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async delete(id) {
    await authentication.isAuthenticated();
    return axios
      .post(this.baseUrl + "/DeleteHours", id, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  }
};
